import React, {useMemo} from 'react';
import {useFormContext, FieldError} from 'react-hook-form';
import {ControllerWrapper} from '@/components/common';
import FileInputUI from '@/components/help/common/FormContainer/FileInputUI/index';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {FORM_FIELDS} from '@/constants/help/form';
import {useFormContainerContext} from '@/components/help/common/FormContainer/FormContainerContext';
import {
  FORM_TYPE_ILLEGAL,
  BASE_ALLOWED_EXTENSIONS,
  ADDITIONAL_EXTENSIONS_FOR_ILLEGAL,
  MAX_FILES,
  MAX_SIZE_MB,
  MAX_SIZE_BYTES,
} from '@/constants/help/index';

const AttachedFiles = () => {
  const {
    formState: {errors},
    trigger,
  } = useFormContext();
  const {type} = useFormContainerContext();

  const allowedExtensions = useMemo(() => {
    if (type === FORM_TYPE_ILLEGAL) {
      return [...BASE_ALLOWED_EXTENSIONS, ...ADDITIONAL_EXTENSIONS_FOR_ILLEGAL];
    }
    return BASE_ALLOWED_EXTENSIONS;
  }, [type]);

  const validateFiles = (value: File[]) => {
    // 파일이 없으면 검사 통과
    if (!value || value.length === 0) {
      return true;
    }

    // 1. 파일 개수 검사
    if (value.length > MAX_FILES) {
      return `${MAX_FILES}개 이하의 파일만 첨부할 수 있습니다.`;
    }

    // 2. 전체 용량 검사
    const totalSize = value.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > MAX_SIZE_BYTES) {
      return `${MAX_SIZE_MB}MB 이하의 파일만 첨부 가능합니다.`;
    }

    // 3. 파일 형식 검사
    for (const file of value) {
      const extension = file.name
        .slice(file.name.lastIndexOf('.'))
        .toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        return `첨부 불가한 파일입니다.`;
      }
    }

    // 모든 검사를 통과하면 유효함
    return true;
  };

  return (
    <div className={styles.section} id='attachedFiles-wrapper'>
      <label className={styles.label}>첨부 파일</label>
      <ControllerWrapper
        name={FORM_FIELDS.FILES}
        component={FileInputUI}
        placeholder='파일 첨부'
        rules={{
          validate: validateFiles,
        }}
        triggerValidation={trigger} // 파일 추가 시 유효성 검사 트리거
        error={errors.attachedFiles as FieldError}
      />
    </div>
  );
};

export default AttachedFiles;
